import type { NavigationPlaceDescriptor } from '@efficiently/client-core-navigation';
import { PROJECTS_MODULE_ROUTES, toRouteParam } from '@efficiently/client-core-routing';

import { DIVISION_NAVIGATION_KEY } from '../../../navigation/division-navigation-key.constant';
import { BOOK_ROUTES } from '../book/book-routing.const';
import { BOOKS_ROUTES } from '../books-routing.const';

/** One page of a book in Design Books, a place the agent may open. */
export const DESIGN_BOOK_PAGE_NAVIGATION_PLACE: NavigationPlaceDescriptor = {
	placeKey: 'design-book-page',
	path: BOOK_ROUTES.PAGE.fullPath(
		toRouteParam(PROJECTS_MODULE_ROUTES.ROOT.PARAMS.PROJECT_ID),
		toRouteParam(BOOKS_ROUTES.PAGES.PARAMS.BOOK_ITEM_ID),
		toRouteParam(BOOK_ROUTES.PAGE.PARAMS.PAGE_ID),
	),
	keys: [DIVISION_NAVIGATION_KEY],
};
